/**
 * TopCaregiversTable — Top 10 caregivers by alarm volume.
 */

import { Link } from 'react-router-dom';
import { exportWellnessCsv } from '../../../../services/csvExport.js';
import { formatDateNoYear, getToday } from '../../../../libs.jsx';

const weekRanges = [
    `${formatDateNoYear(getToday(-7))}–${formatDateNoYear(getToday(-1))}`,
    `${formatDateNoYear(getToday(-14))}–${formatDateNoYear(getToday(-8))}`,
    `${formatDateNoYear(getToday(-21))}–${formatDateNoYear(getToday(-15))}`,
    `${formatDateNoYear(getToday(-28))}–${formatDateNoYear(getToday(-22))}`,
];

const CSV_COLS = [
    { key: 'display_name', label: 'Caregiver' },
    { key: 'avg_daily_events', label: 'Total' },
    { key: 'week1', label: 'Week 1' },
    { key: 'week2', label: 'Week 2' },
    { key: 'week3', label: 'Week 3' },
    { key: 'week4', label: 'Week 4' },
    { key: 'avg_response_time', label: 'Avg Response (min)' },
];

const TopCaregiversTable = ({ data }) => {
    const rows = Array.isArray(data) ? data.slice(0, 10) : [];

    return (
        <div className="md-section">
            <div className="md-section__header">
                <h3 className="md-section__title">Top 10 Caregiver Review</h3>
                {rows.length > 0 ? (
                    <button className="rp-btn rp-btn--secondary" onClick={() => exportWellnessCsv(rows, CSV_COLS, 'top-caregivers.csv')} style={{ fontSize: 'var(--font-size-xs)', padding: '4px 10px' }}>
                        <i className="fe fe-download" style={{ marginRight: '4px' }} />CSV
                    </button>
                ) : null}
            </div>
            <div className="dp-table-wrap">
                <table className="dp-table">
                    <thead className="dp-thead">
                        <tr>
                            <th rowSpan={2} className="dp-th">Caregiver</th>
                            <th colSpan={5} className="dp-th" style={{ textAlign: 'center' }}>Average Daily Events</th>
                            <th rowSpan={2} className="dp-th" style={{ textAlign: 'center' }}>Avg Response (min)</th>
                        </tr>
                        <tr>
                            <th className="dp-th" style={{ textAlign: 'center' }}>Total</th>
                            <th className="dp-th" style={{ textAlign: 'center' }}>{weekRanges[0]}</th>
                            <th className="dp-th" style={{ textAlign: 'center' }}>{weekRanges[1]}</th>
                            <th className="dp-th" style={{ textAlign: 'center' }}>{weekRanges[2]}</th>
                            <th className="dp-th" style={{ textAlign: 'center' }}>{weekRanges[3]}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 ? (
                            <tr className="dp-tr"><td className="dp-td" colSpan={7} style={{ textAlign: 'center' }}><span className="dp-cell-text dp-cell-text--muted">No caregiver data</span></td></tr>
                        ) : null}
                        {rows.map((r, i) => (
                            <tr key={i} className="dp-tr">
                                <td className="dp-td">{r.user_id ? <Link to={`/profiles/user/${r.user_id}`} className="pp-field__value--link">{r.display_name}</Link> : (r.display_name || '—')}</td>
                                <td className="dp-td" style={{ textAlign: 'center' }}>{r.avg_daily_events ?? '-'}</td>
                                <td className="dp-td" style={{ textAlign: 'center' }}>{r.week1 ?? '-'}</td>
                                <td className="dp-td" style={{ textAlign: 'center' }}>{r.week2 ?? '-'}</td>
                                <td className="dp-td" style={{ textAlign: 'center' }}>{r.week3 ?? '-'}</td>
                                <td className="dp-td" style={{ textAlign: 'center' }}>{r.week4 ?? '-'}</td>
                                <td className="dp-td" style={{ textAlign: 'center' }}>{r.avg_response_time ?? '—'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TopCaregiversTable;
